// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "AppointmentTypesList-module--wrapper--Bgl6l";
export var item = "AppointmentTypesList-module--item--xdZgT";
export var otherItem = "AppointmentTypesList-module--otherItem--K1XWK";